module.exports = __webpack_public_path__ + "img/logo-company-2.7a367922.png";